module.exports = __webpack_public_path__ + "img/goods.b2fba1c4.png";